import AuthContext from "@ane/core/lib/services/MSALAuthService/MSALAuthService";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { isWorkspacePayload, isEntityIdPayload } from "./types.js";
import { getResourceUrlSegment } from "./utils.js";
const mockGetAuthToken = () => vi.spyOn(AuthContext, "getToken").mockResolvedValue("token");
const getHandlerPath = (resource, payload, useGenericPathParams = false, secondaryResource) => {
  if (useGenericPathParams && isWorkspacePayload(payload)) {
    payload.workspaceId = ":workspaceId";
  }
  if (useGenericPathParams && isEntityIdPayload(payload)) {
    payload.id = ":id";
  }
  return `${EnvironmentService.endpoints.default.url}/${getResourceUrlSegment(resource, payload, void 0, secondaryResource)}`;
};
const parsePathParams = (params) => {
  const { workspaceId, id } = params;
  const workspaceIdString = workspaceId;
  const idString = id;
  return { workspaceId: workspaceIdString, id: idString };
};
export {
  getHandlerPath,
  mockGetAuthToken,
  parsePathParams
};
//# sourceMappingURL=testutils.js.map
